var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('horizontal-bar-chart',{style:('width: 100%; min-height:200px; height:'+ _vm.uniqueReasons.length * 20+'px'),attrs:{"chartData":_vm.getChartData,"options":_vm.getOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }